import React, {Component} from 'react';
import CONSTANTS from '../../config/constants'
import _ from 'lodash';

class OnboardingBlock extends Component {
    getContentFieldValue = (fieldDefinitionKey) => {
        const {contentFields} = this.props;
        const data = _.find(contentFields, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;

        let w = 60;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    render() {
        return (
            <section className={"quickguide-block w--" + this.getBlockWidth() + " show--shadow"}>
                <section className="quickguide-block--inner">
                    <h3>{this.getContentFieldValue('Title')}</h3>
                    <div dangerouslySetInnerHTML={{__html: this.getContentFieldValue('Body')}}/>
                </section>
            </section>
        );
    }
}

export default OnboardingBlock;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/OnboardingBlock.js